//柬埔寨站点
export default {
  WebSiteId: 9,
  SearchType1: true, //搜索栏本地商城
  SearchType2: true, //搜索栏店铺
  seller: true,
  LODAMall: true,
  LODALive: true,
  LodaFood: false,
  LODAAPP: true,
  Applink: true,
  ExpressNotices: true,
  RecommendModular: true,
  Activities: true,
  Mailbox: 'Service@loda.com.kh',
  lodaDelivery: true,
  AboutUs: true,
  weixin: true,
  invitation: true,
  article: {
    'zh-cn': [
      1160324,
      null,
      1160371,
      1160340,
      1160379,
      1160402,
      1160423,
      1160378,
      1160506,
    ],
    en: [
      1160325,
      null,
      1160401,
      1160341,
      1160380,
      1160427,
      1160424,
      1160428,
      1160507,
    ],
    km: [
      1160326,
      null,
      1160400,
      1160342,
      1160381,
      1160426,
      1160425,
      1160429,
      1160508,
    ],
  },
  ExternalLogin: true,
  stationLetter: true,
  coupons: true,
  NoEmail:
    typeof JSON.parse(localStorage.getItem('GetAppConfig'))
      ?.needEmailRegister == 'boolean'
      ? JSON.parse(localStorage.getItem('GetAppConfig'))?.needEmailRegister
      : false,
  areaCode: true,
  LODA: 'LODA Cambodia',
  LODAGoogle: 'https://www.googletagmanager.com/gtag/js?id=UA-69628131-1',
  LODAGoogleCode:
    "window.dataLayer = window.dataLayer || [];function gtag() { dataLayer.push(arguments); }gtag('js', new Date());gtag('config', 'UA-69628131-1');",
  logoPng: 'LODA.png',
  login_banner: 'login_banner_cn.jpg',
  login_bgColor: '#dd5246',
  title:
    'LODA កម្ពុជា - Cambodia Online Shopping Platform | Wholesale & Purchasing, International Shipping & Delivery Express, Food Delivery, Mall',
  keywords:
    'LODA,online shopping,purchasing,wholesale,international shipping,delivery,express,food delivery,marketplace,mall,product,coupons,B2B,B2C,online transactions,shopping,China,Cambodia',
  default_description:
    'LODA Cambodia (loda.com.kh) is the largest online shopping e-commerce platform in Cambodia, providing e-commerce services such as online shopping, wholesale & purchasing, international shipping & delivery express, food delivery, local mall. We offer a wide range of products for you to choose from, and various promotions such as coupons and flash sales to help you save even more.',
  ShowMallType: true,
  symbol: '$ ',
  CurrencyCode: 'USD ',
  separator: ',',
  precision: 2,
  lans: {
    km: { val: 'km', name: 'កម្ពុជា។' },
    'zh-cn': { val: 'zh-cn', name: '中文' },
    en: { val: 'en', name: 'English' },
  },
  DefaultMapcenter: { lat: 11.5466075, lng: 104.9005807 },
  getPlacePredictions: 'kh',
  translateLan: 'zh-CN',
  OrderStatu: [
    { name: '全部订单', StatuId: null },
    { name: '待审核', StatuId: 1 },
    { name: '待付款', StatuId: 2 },
    { name: '订购中', StatuId: 3 },
    { name: '已入库（中国仓）', StatuId: 4 },
    { name: '国际运输中', StatuId: 5 },
    { name: '已入库（本地仓）', StatuId: 6 },
    { name: '待收货', StatuId: 7 },
    { name: '已完成', StatuId: 8 },
    { name: '取消', StatuId: 9 },
    { name: '售后', StatuId: 20 },
  ],
  sources: [
    { name: '全部', val: null },
    { name: '海外购', val: '5' },
    { name: '商城', val: '10' },
    { name: '话费', val: '40' },
  ],
  WorkingHours1_5: '09:00-18:00',
  WorkingHours6_7: '08:00-17:00',
}
